

export default class JobsTimelineRequest  {
	FromDate!: Date;
	ToDate!: Date;
	ProjectId!: number;
	JobsIds!: Array<string>;
	constructor(obj?: Partial<JobsTimelineRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
